module.exports = __webpack_public_path__ + "assets/img/give-2w.c0f9765e.png";